import React from 'react';
import { IIconProps, IconHeight, IconSizes, IconWidth } from './type';

const BadgeAntiWaste: React.FC<IIconProps> = ({
  size = IconSizes.sm,
  UNSAFE_className,
  ...props
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={IconWidth[size]}
      height={IconHeight[size]}
      viewBox="0 0 16 17"
      fill="none"
      className={UNSAFE_className || ''}
      {...props}
    >
      <path
        d="M2.93995 9.5395H4.06789C4.31854 9.5395 4.50653 9.35689 4.50653 9.11341V2.66124C4.50653 2.41776 4.69452 2.23515 4.94517 2.23515H11.1488C11.3995 2.23515 11.5875 2.41776 11.5875 2.66124V9.17428C11.5875 9.41776 11.7755 9.60037 12.0261 9.60037H13.154C13.2167 9.66124 13.2167 9.66124 13.154 9.72211L8.07833 14.6525H7.953L2.93995 9.72211C2.93995 9.72211 2.93995 9.72211 2.93995 9.66124C2.87728 9.60037 2.93995 9.5395 2.93995 9.5395Z"
        fill="#FF573E"
      />
      <path
        d="M6.32376 6.80037C7.01305 6.80037 7.57702 6.25254 7.57702 5.58298C7.57702 4.91341 7.01305 4.36559 6.32376 4.36559C5.63446 4.36559 5.0705 4.91341 5.0705 5.58298C5.0705 6.25254 5.63446 6.80037 6.32376 6.80037ZM6.32376 5.21776C6.57441 5.21776 6.7624 5.40037 6.7624 5.64385C6.7624 5.88733 6.57441 6.06993 6.32376 6.06993C6.07311 6.06993 5.88512 5.88733 5.88512 5.64385C5.94778 5.40037 6.13577 5.21776 6.32376 5.21776Z"
        fill="black"
      />
      <path
        d="M8.45431 8.86993C8.45431 9.5395 9.01828 10.0873 9.70757 10.0873C10.3969 10.0873 10.9608 9.5395 10.9608 8.86993C10.9608 8.20037 10.3969 7.65254 9.70757 7.65254C9.01828 7.65254 8.45431 8.20037 8.45431 8.86993ZM10.1462 8.86993C10.1462 9.11341 9.95822 9.29602 9.70757 9.29602C9.45692 9.29602 9.26893 9.11341 9.26893 8.86993C9.26893 8.62646 9.45692 8.44385 9.70757 8.44385C9.95822 8.44385 10.1462 8.62646 10.1462 8.86993Z"
        fill="black"
      />
      <path
        d="M6.38642 10.0265C6.44909 10.0873 6.51175 10.0873 6.57441 10.0873C6.69974 10.0873 6.88773 10.0265 6.95039 9.90472L9.8329 5.03515C9.95822 4.85254 9.89556 4.60906 9.70757 4.48733C9.51958 4.36559 9.26893 4.42646 9.1436 4.60907L6.2611 9.47863C6.07311 9.66124 6.19843 9.90472 6.38642 10.0265Z"
        fill="black"
      />
      <path
        d="M2.37598 10.2699L7.38903 15.2004C7.57702 15.383 7.76501 15.4438 8.01567 15.4438C8.26632 15.4438 8.51697 15.3221 8.6423 15.2004L13.718 10.2699C14.094 9.90472 14.094 9.35689 13.718 8.99167C13.53 8.80906 13.342 8.7482 13.0914 8.7482H12.4021V2.66124C12.4021 1.99167 11.8381 1.44385 11.1488 1.44385H4.94517C4.25587 1.44385 3.69191 1.99167 3.69191 2.66124V8.7482H2.93995C2.43864 8.7482 2 9.17428 2 9.66124C2.06266 9.90472 2.18799 10.1482 2.37598 10.2699ZM2.93995 9.5395H4.06789C4.31854 9.5395 4.50653 9.35689 4.50653 9.11341V2.66124C4.50653 2.41776 4.69452 2.23515 4.94517 2.23515H11.1488C11.3995 2.23515 11.5875 2.41776 11.5875 2.66124V9.17428C11.5875 9.41776 11.7755 9.60037 12.0261 9.60037H13.154C13.2167 9.66124 13.2167 9.66124 13.154 9.72211L8.07833 14.6525H7.953L2.93995 9.72211C2.93995 9.72211 2.93995 9.72211 2.93995 9.66124C2.87728 9.60037 2.93995 9.5395 2.93995 9.5395Z"
        fill="black"
      />
    </svg>
  );
};

export default BadgeAntiWaste;
